<template>
  <v-dialog :value="showModal" persistent width="500">
    <v-card class="pa-5">
      <div class="text-center">
        <h3>{{ $t("exchange.preconditionOrderInfoModal.title") }}</h3>
      </div>
      <div class="font-Regular-14 text-justify">
        <v-radio-group v-model="stopOrderType" row>
          <v-radio
            :label="$t('exchange.preconditionOrderInfoModal.buyOrder')"
            value="buy"
          >
          </v-radio>
          <v-radio
            :label="$t('exchange.preconditionOrderInfoModal.sellOrder')"
            value="sell"
          >
          </v-radio>
        </v-radio-group>
        <v-row class="mx-3" v-if="stopOrderType === 'buy'">
          <img alt="" src="@/assets/image/infoBuy.svg" />
          <p class="mb-4 modal-text">
            {{ $t("exchange.preconditionOrderInfoModal.desc1") }}
          </p>
          <p class="mb-4 modal-text">
            {{ $t("exchange.preconditionOrderInfoModal.desc2") }}
          </p>
          <p class="mb-4 modal-text">
            {{ $t("exchange.preconditionOrderInfoModal.desc3") }}
          </p>
        </v-row>
        <v-row class="mx-3" v-if="stopOrderType === 'sell'">
          <img alt="" src="@/assets/image/infoSell.svg" />
          <p class="mb-4 modal-text">
            {{ $t("exchange.preconditionOrderInfoModal.desc4") }}
          </p>
          <p class="mb-4 modal-text">
            {{ $t("exchange.preconditionOrderInfoModal.desc5") }}
          </p>
          <p class="mb-4 modal-text">
            {{ $t("exchange.preconditionOrderInfoModal.desc6") }}
          </p>
        </v-row>
      </div>
      <div>
        <v-btn
          class="font-Medium-14 d-block"
          block
          color="primary"
          @click="$emit('onConfirm')"
          >{{ $t("exchange.preconditionOrderInfoModal.understood") }}</v-btn
        >
        <!--        <Button class="font-Medium-14 ms-2" @click="$emit('onCancel')">{{$t('uc.denyTermsOfUse')}}</Button>-->
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "preconditionalOrderInfoModal",
  props: {
    showModal: {
      type: Boolean
    }
  },
  data() {
    return {
      stopOrderType: "buy"
    };
  }
};
</script>
